// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TcEzl","question":"styles_question__2A7-E","description":"styles_description__19DpR"};